export const CONNECT = "CONNECT";

export const UPDATE_WALLET_BALANCE = "UPDATE_WALLET_BALANCE";

export const TOGGLE_MENU = "TOGGLE_MENU";

export const CHANGE_SCREEN_SIZE = "CHANGE_SCREEN_SIZE";

export const UPDATE_AIRDROP_DATA = "UPDATE_AIRDROP_DATA";
